import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoBa: CultureInfo = {
  name: 'ba',
  displayName: 'Bashkir',
  iso3LanguageCode: 'bak',
  iso2LanguageCode: 'ba',
  ietfLanguageTag: 'ba',
  parent: null
};
